// extracted by mini-css-extract-plugin
module.exports = {"container":"post-video-module--container--Bf6pQ","iframe":"post-video-module--iframe--1hqZu"};